import { IContextualMenuItem, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_LoadingFiles(selectedItems: any[], waitFor: boolean, waitForContext: string) {
    const languageStrings = React.useContext(LanguageContext);
       
    const [menuItem_LoadingFiles, setMenuItem_LoadingFiles] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (waitFor === true) {
          setMenuItem_LoadingFiles(
                {
                  key: "loadingFiles",
                  text: `${waitForContext} ${selectedItems.length} ${selectedItems.length === 1 ? languageStrings.Item.toLowerCase() : languageStrings.Items.toLowerCase()}`,
                  disabled: true,
                  onRenderIcon: () => {
                    return <Spinner size={SpinnerSize.small} style={{ paddingRight: 5 }} />
                  }
                }
            )
        } else {
          setMenuItem_LoadingFiles(null)
        }
    }, [selectedItems, waitFor]);

    
    return {
      menuItem_LoadingFiles
    }

}